import { render } from "./StatsUserGender.vue?vue&type=template&id=58dd7c8e"
import script from "./StatsUserGender.vue?vue&type=script&lang=js"
export * from "./StatsUserGender.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fae/dev/grazer/grazer-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__